import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../services/translation.service';

@Pipe({
  name: 'translatePlural',
  pure: false, // Allows automatic recalculation when the language changes
})
export class TranslatePluralPipe implements PipeTransform {
  readonly #translationService = inject(TranslationService);

  public transform(key: string | undefined, count: number, params?: Record<string, string | number>): string {
    if (!key) {
      return '';
    }
    return this.#translationService.getPlural(key, count, params);
  }
}
